document.querySelectorAll('.details-one-time').forEach((elem) => {
  elem.addEventListener('click', function(event) {
    if (!this.open) {
      document.querySelectorAll('.details-one-time').forEach((otherElem) => {
        if (otherElem !== this) {
          otherElem.open = false;
        }
      });
      this.open = true;
      event.preventDefault();
    }
  });
});


(function () {
  "use strict";

  let footer,
    footerInner,
    stickyFooterElement,
    footerHeight,
    footerScaleRatio,
    isFooterVisible = false;

  function initFooter(e) {
    footer = document.querySelector(e);
    footerInner = footer.querySelector(".footer__inner");
    stickyFooterElement = document.querySelector(
      ".sticky-footer-click-through-element"
    );
    bindEvents();
  }

  function bindEvents() {
    const resizeHandler = function () {
      updateFooterHeight(window.innerWidth, window.innerHeight);
    };

    resizeHandler();

    window.addEventListener("resize", resizeHandler);
    window.addEventListener("scroll", function () {
      updateFooterVisibility(window.pageYOffset || window.scrollY);
    });

    document.querySelectorAll(".footer__details").forEach((detail) => {
      detail.addEventListener("toggle", handleDetailsToggle);
    });

    setTimeout(resizeHandler, 1500);
    setTimeout(resizeHandler, 3000);
    setTimeout(resizeHandler, 5000);
    setTimeout(resizeHandler, 9000);
  }

  function updateFooterHeight(windowWidth, windowHeight) {
    footerHeight = footer.offsetHeight;

    stickyFooterElement.style.height = footerHeight + "px";
    footerScaleRatio = windowWidth < 900 ? 0.7 : 0.9;
  }

  function updateFooterVisibility(scrollY) {
    const bodyOffset =
      document.body.offsetHeight - window.innerHeight - scrollY;

    if (bodyOffset > footerHeight) {
      if (isFooterVisible) {
        stickyFooterElement.style.backgroundColor = "rgba(242, 255, 194, 1)";
        isFooterVisible = false;
        document.body.classList.remove("footer-visible");
        document.body.classList.remove("footer-full-visible");
      }
      return;
    }

    isFooterVisible = true;
    document.body.classList.add("footer-visible");

    const scrollRatio = bodyOffset / (footerHeight * 0.87);
    stickyFooterElement.style.backgroundColor =
      "rgba(242,255,194," + scrollRatio + ")";

    const scaleRatio = Math.min(
      footerScaleRatio + (1 - footerScaleRatio) * (1 - scrollRatio),
      1
    );
    footerInner.style.transform = "scale(" + scaleRatio + ")";

    if (scaleRatio === 1) {
      document.body.classList.add("footer-full-visible");
    } else {
      document.body.classList.remove("footer-full-visible");
    }
  }

  function handleDetailsToggle(event) {
    console.log("Details toggled");

    setTimeout(() => {
      updateFooterHeight(window.innerWidth, window.innerHeight);

      const scrollPosition = window.pageYOffset || window.scrollY;
      updateFooterVisibility(scrollPosition);

      const bodyHeight = document.body.offsetHeight;
      const windowHeight = window.innerHeight;
      const bottomPosition = bodyHeight - windowHeight;

      if (scrollPosition < bottomPosition) {
        console.log("Attempting to scroll to", bottomPosition);
        window.scrollTo({
          top: bottomPosition,
          behavior: "smooth",
        });
      } else {
        console.log("No need to scroll");
      }
    }, 50);
  }

  initFooter(".footer");
})();